const S3_PROVIDER_PRESETS = {
	dealerslink: {
		s3_prefix: 'dealerslink/',
		importer_class: 'DealerslinkImporter',
		feed_path_env: 'DEALERSLINK_FEED_PATH',
	},
	dealersocket: {
		s3_prefix: 'dealersocket/',
		importer_class: 'DealersocketImporter',
		feed_path_env: 'DEALERSOCKET_FEED_PATH',
	},
	dealertrack: {
		s3_prefix: 'dtrack/',
		importer_class: 'DealertrackImporter',
		feed_path_env: 'DEALERTRACK_FEED_PATH',
	},
	frazer: {
		s3_prefix: 'frazer/',
		importer_class: 'FrazerImporter',
		feed_path_env: 'FRAZER_FEED_PATH',
	},
	googledrive: {
		s3_prefix: 'googledrive/',
		importer_class: 'GoogledriveImporter',
		feed_path_env: 'GOOGLEDRIVEIMPORTER_FEED_PATH',
	},
	homenet: {
		s3_prefix: 'homenet/',
		importer_class: 'HomenetImporter',
		feed_path_env: 'HOMENET_FEED_PATH',
	},
	ipacket_advent: {
		s3_prefix: 'fletcherjones/',
		importer_class: 'IpacketAdventImporter',
		feed_path_env: 'IPACKET_ADVENT_FEED_PATH',
	},
	ipacket_arcadium: {
		s3_prefix: 'arcadium/',
		importer_class: 'IpacketArcadiumImporter',
		feed_path_env: 'IPACKET_ARCADIUM_FEED_PATH',
	},
	ipacket_autoverify: {
		s3_prefix: 'autoverify/',
		importer_class: 'IpacketAutoverifyImporter',
		feed_path_env: 'IPACKET_AUTOVERIFY_FEED_PATH',
	},
	ipacket_d2c: {
		s3_prefix: 'd2c/',
		importer_class: 'IpacketD2cImporter',
		feed_path_env: 'IPACKET_D2C_FEED_PATH',
	},
	ipacket_dds: {
		s3_prefix: 'dds/',
		importer_class: 'IpacketDdsImporter',
		feed_path_env: 'IPACKET_DDS_FEED_PATH',
	},
	ipacket_dealercenter: {
		s3_prefix: 'dealercenter/',
		importer_class: 'IpacketDealercenterImporter',
		feed_path_env: 'IPACKET_DEALERCENTER_FEED_PATH',
	},
	ipacket_dealercom: {
		s3_prefix: 'dealercom/',
		importer_class: 'IpacketDealercomImporter',
		feed_path_env: 'IPACKET_DEALERCOM_FEED_PATH',
	},
	ipacket_dealercue: {
		s3_prefix: 'dealercue/',
		importer_class: 'IpacketDealercueImporter',
		feed_path_env: 'IPACKET_DEALERCUE_FEED_PATH',
	},
	ipacket_dealerslink: {
		s3_prefix: 'dealerslink/',
		importer_class: 'IpacketDealerslinkImporter',
		feed_path_env: 'IPACKET_DEALERSLINK_FEED_PATH',
	},
	ipacket_dealersocket: {
		s3_prefix: 'dealersocket/',
		importer_class: 'IpacketDealersocketImporter',
		feed_path_env: 'IPACKET_DEALERSOCKET_FEED_PATH',
	},
	ipacket_ebizautos: {
		s3_prefix: 'ebizautos/',
		importer_class: 'IpacketEbizautosImporter',
		feed_path_env: 'IPACKET_EBIZAUTOS_FEED_PATH',
	},
	ipacket_edealerca: {
		s3_prefix: 'edealerca/',
		importer_class: 'IpacketEdealercaImporter',
		feed_path_env: 'IPACKET_EDEALERCA_FEED_PATH',
	},
	ipacket_homenet: {
		s3_prefix: 'homenet/',
		importer_class: 'IpacketHomenetImporter',
		feed_path_env: 'IPACKET_HOMENET_FEED_PATH',
	},
	ipacket_inventorycommand: {
		s3_prefix: 'inventorycommand/',
		importer_class: 'IpacketInventorycommandImporter',
		feed_path_env: 'IPACKET_INVENTORYCOMMAND_FEED_PATH',
	},
	ipacket_inventoryplus: {
		s3_prefix: 'inventoryplus/',
		importer_class: 'IpacketInventoryplusImporter',
		feed_path_env: 'IPACKET_INVENTORYPLUS_FEED_PATH',
	},
	ipacket_promax: {
		s3_prefix: 'promax/',
		importer_class: 'IpacketPromaxImporter',
		feed_path_env: 'IPACKET_PROMAX_FEED_PATH',
	},
	ipacket_vauto: {
		s3_prefix: 'vauto/',
		importer_class: 'IpacketVautoImporter',
		feed_path_env: 'IPACKET_VAUTO_FEED_PATH',
	},
	vauto: {
		s3_prefix: 'vauto/',
		importer_class: 'VautoImporter',
		feed_path_env: 'VAUTO_FEED_PATH',
	},
};

export default S3_PROVIDER_PRESETS;
